import { render, staticRenderFns } from "./teskManageOEM.vue?vue&type=template&id=320082d4&"
import script from "./teskManageOEM.vue?vue&type=script&lang=ts&"
export * from "./teskManageOEM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports